import { Prop, Watch } from 'vue-property-decorator';
import P63Vue from '@/system/P63Vue';
import Component from 'vue-class-component';
import gStatS from '@/common/service/StatS';

@Component
export default class modal_ab_register extends P63Vue {
    @Prop({ type: Boolean, default: false }) bShowModalA: boolean;

    /** Показ модалки */
    bShowModal: boolean = true;
    /** HTML Элемент модалки */
    elModal: HTMLElement = null;
    /** Элемент кнопки "Зарегистрироваться" */
    elRegisterBtn: HTMLElement = null;
    /** Элемент бэкграунда */
    elBackground: HTMLElement = null;
    /** Элемент jdiv */
    elJdiv: HTMLElement = null;
    /** Стартовая позиция модалки */
    nStartPosY: number = 270;
    /** Окончательная позиция модалки */
    nEndPosY: number = 0;
    /** Текущая точка при движении модалки */
    nTransformY: number = 500;
    /** Высота модалки */
    nModalHeight: number = 500;
    /** Скорость трансформации */
    nTransitionSpeed: number = 0;
    /** Начальная точка касания */
    nTouchStartCoordinateY: number = null;
    /** Трансформация модалки в начале движения пальцем */
    nMoveStartCoordinateY: number;

    @Watch('nTransformY')
    fSmoothClose(){
        if (!this.bShowModalA){
            if (this.elBackground && this.elRegisterBtn){
                if (this.nTransformY > this.nStartPosY){
                    const nOffset: number = (this.nModalHeight - this.nTransformY) / 200;
                    this.elBackground.style.opacity = String(nOffset);
                }
                if (this.nTransformY > this.nModalHeight - 64){
                    this.elRegisterBtn.style.transition = '2s'
                    this.elRegisterBtn.style.transform = `translateY(${this.nTransformY - this.nModalHeight + 64}px)`;
                }
            }
        }
    }

    /** Обработчик начала касания */
    fTouchStartHandler(e){
        this.nTouchStartCoordinateY = e.changedTouches[0].clientY;
        this.nMoveStartCoordinateY = this.nTransformY;
        this.nTransitionSpeed = 0;
    }

    /** Обработчик движения */
    fTouchMoveHandler(e){
        const nCurrentY: number = e.changedTouches[0].clientY;
        const nStartEndDiff: number = this.nTouchStartCoordinateY - nCurrentY;
        const nNewTransform: number = this.nMoveStartCoordinateY - nStartEndDiff;

        if (nNewTransform > this.nEndPosY){
            this.nTransformY = nNewTransform;
        }
    }

    /** Обработчик окончания косания */
    fTouchEndHandler(e){
        this.nTouchStartCoordinateY = null;
        this.nMoveStartCoordinateY = null;
        /** Переместить модалку на конечную позицию */
        const bMoveToEnd: boolean = this.nTransformY < this.nEndPosY + 180;
        /** Скрыть модалку при свайпе вниз */
        const bHideModal: boolean = this.nTransformY > this.nModalHeight - 120;


            /** Предотвращение доводки при повторном взаимодействии с модалкой */
        if (!this.nTouchStartCoordinateY){
            /** Движение к конечной позиции модалки */
            if (bMoveToEnd){
                this.nTransitionSpeed = 1;
                this.nTransformY = this.nEndPosY;
            }
            /** Скрытие модалки */
            else if (bHideModal){
                this.fOnModalClose();
            }
            /** Движение к стартовой позиции */
            else {
                this.nTransitionSpeed = 1;
                this.nTransformY = this.nStartPosY;
            }
        }
    }

    /** Движение модалки к начальной позиции */
    fMoveToStartPos(){
        this.nTransitionSpeed = 3;
        this.elRegisterBtn.style.transition = '1s'
        setTimeout(() => {
            this.nTransformY = this.nStartPosY;
            this.elRegisterBtn.style.transform = 'translateY(0px)';
        }, 0);
    }

    /** Отключение скролла на время показа модалки */
    fDisableOrEnableScroll(bDisable: boolean) {
        if (bDisable){
            document.body.classList.add("stop-scrolling");
        } else {
            document.body.classList.remove("stop-scrolling");
        }
    }

    /** Перейти к регистрации */
    fGoToRegister(){
        const sAlias: string = this.bShowModalA ? 'reg_modal_a_ok' : 'reg_modal_b_ok';
        gStatS.faPushClickToStat({
            page: location.pathname,
            type: 'modal',
            alias: sAlias,
            entity_id: 0,
        })
        window.location.href = `/auth#/register/?alias=${sAlias}`
        this.fCloseModal();
    }

    /** Регистрация закрытия модалки */
    fOnModalClose(){
        gStatS.faPushClickToStat({
            page: location.pathname,
            type: 'modal',
            alias: this.bShowModalA ? 'reg_modal_a_close' : 'reg_modal_b_close',
            entity_id: 0,
        })
        this.fCloseModal();
    }

    /** Закрыть модалку */
    fCloseModal(){
        this.fDisableOrEnableScroll(false);

        if (this.bShowModalA){
            this.bShowModal = false;
        } else {
            this.nTransitionSpeed = 1;
            this.nTransformY = this.nModalHeight;
            setTimeout(() => {
                this.bShowModal = false;
            },  this.nTransitionSpeed * 1000);
        }
    }

    /** Отправить данные в статистику о показе модалки */
    fSendActionModalShown(){
        const sAlias: string = this.bShowModalA ? 'reg_modal_a' : 'reg_modal_b';
        gStatS.faPushClickToStat({
            page: location.pathname,
            type: 'modal',
            alias: sAlias,
            entity_id: 0,
        })
    }

    mounted(){
        /** Отключение возможности прокрутки страницы */
        this.fDisableOrEnableScroll(true);
        /** Находим jdiv элемент */
        this.elJdiv = document.querySelector('jdiv') as HTMLElement;
        /** Скрываем jdiv */
        if (this.elJdiv){
            this.elJdiv.style.display = 'none';
        }

        if (!this.bShowModalA){
            /** Находим элемент модалки */
            this.elModal = this.$refs.modalB as HTMLElement;
            /** Находим кнопку регистрации */
            this.elRegisterBtn = this.$refs.btn as HTMLElement;
            /** Находим бэкграуннд */
            this.elBackground = this.$refs.background as HTMLElement;
            /** Положение модалки за пределами экрана */
            this.nTransformY = this.nModalHeight;
            /** Слушатели событий "touch" для обработки "вытягивания" модалки */
            this.elModal.addEventListener('touchstart', this.fTouchStartHandler);   // Нчало касания
            this.elModal.addEventListener('touchmove', this.fTouchMoveHandler); // Движение
            this.elModal.addEventListener('touchend', this.fTouchEndHandler); // Окончание косания

            /** Двигаем модалку к начальной позиции */
            this.fMoveToStartPos();
        }
        /** Отправка данных о показе модалки */
        this.fSendActionModalShown();
    }

    beforeDestroy(){
        /** Снимаем слушатели */
        this.elModal.removeEventListener('touchstart', this.fTouchStartHandler);
        this.elModal.removeEventListener('touchmove', this.fTouchMoveHandler);
        this.elModal.removeEventListener('touchend', this.fTouchEndHandler);

        /** Возвращаем jdiv */
        if (this.elJdiv){
            this.elJdiv.style.display = 'inline';
        }
    }
}
